// extracted by mini-css-extract-plugin
module.exports = {"Title":"index-module--Title--2QmBg","SmallMessage":"index-module--SmallMessage--1IfrQ","CancelIcon":"index-module--CancelIcon--3xXL5"};